import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import {SummaryInfoComponent} from '../summary-info/summary-info.component';
import { CompanyService } from 'src/app/services/company.service';
import { Subject } from 'rxjs';
import { FreeTrialService } from '../free-trial.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-client-company',
  templateUrl: './client-company.component.html',
  styleUrls: ['./client-company.component.scss']
})
export class ClientCompanyComponent implements OnInit {

  companyId;
  tabsList: any[];
  index = 0;
  activeTabIndex = 0;
  observableSubscription$ = new Subject();
  editingContent = false;
  @ViewChild(SummaryInfoComponent) summaryInfoComponent: SummaryInfoComponent;

  currentState = '';
  toastr: any;

  constructor( private activatedRoute: ActivatedRoute,
               private companyService: CompanyService, 
               private freeTrialService: FreeTrialService,
               public dialogRef: MatDialogRef<ClientCompanyComponent>,
               @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log('data passed in is:', this.data);
    this.activatedRoute.params
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe(parameter => {
        let parameterId = null;
        if (parameter.hasOwnProperty('id')) {
          parameterId = parameter.id;
          this.editingContent = true;
          this.companyId = parameterId;
          this.companyService.getCompaniesById(parameter.id).subscribe(data => {
            this.currentState = data.status.code;
            if (this.editingContent && this.currentState == 'ACTV'){
              this.tabsList = [
                { 'tabName':'1. Company Info','tabIconName':'Petition'},
              ];
            }
            else {
            this.tabsList = [
              { 'tabName':'Add Company Details','tabIconName':'Petition'},
              { 'tabName':'Add User','tabIconName':'Petition'},
            ];
            }
          });
        } else {
          this.tabsList = [
            { 'tabName':'Add Company Details','tabIconName':'Petition'},
            { 'tabName':'Add User','tabIconName':'Petition'},
          ];
        }
      });
  }

  ngOnInit() {
  }

  handleChange(e) {
    this.activeTabIndex = e.index;
  }

  parentListener(data:number){
    console.log('data :-------' + data);
    this.activeTabIndex = data;
    // if(data == 1){
    //   this.otherDocumentComponent.getallData();
    // }
    // if(data == 1){
    //   this.selectRolesComponent.getUserRoles();
    //   this.selectRolesComponent.getUserDetails();
    // }
    // if(data == 2){
    //   this.creatingUsersComponent.getUserRoles();
    // }
    if(data == 0){
      this.freeTrialService.getCompanyClientFirmInfo();
      // this.companyDetailsForm.patchValue({
      //   beneficiaryName: beneficiaryData.firstName + " " + beneficiaryData.lastName,
      // });
    }
    if(data == 1){
      // this.summaryInfoComponent.getReviewSummaryDetails();
    //  this.freeTrialService.getattorneyUserInfoArray();
    }
  }

  idListener(data:number){
    this.companyId = data;
  }
}
